export default IconHorseToy => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-horse-toy" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3.5 17.5c5.667 4.667 11.333 4.667 17 0" />
  <path d="M19 18.5l-2 -8.5l1 -2l2 1l1.5 -1.5l-2.5 -4.5c-5.052 .218 -5.99 3.133 -7 6h-6a3 3 0 0 0 -3 3" />
  <path d="M5 18.5l2 -9.5" />
  <path d="M8 20l2 -5h4l2 5" />
</svg>`;